import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalenderComponent } from '../components/calender/calender.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';
import { PImgPage } from './components/p-img/p-image.page';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [CalenderComponent, PImgPage],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
  ],
  exports: [
    CalenderComponent,
    PImgPage,
    MatIconModule,
    IonicModule,
    MatSelectModule,
    MatTooltipModule,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
